import type { MouseEvent } from 'react'

import { MorningLogoMark } from '@/components/morning-logo-mark'
import { MorningLogoWordmark } from '@/components/morning-logo-wordmark'
import type { StickyHeaderScrolledScheme } from '@/hooks/use-has-scrolled'
import { cn } from '@/lib/utils'

type MorningLogoLinkProps = {
  className?: string
  wordmarkClassName?: string
  iconWrapClassName?: string
  iconClassName?: string
  scrolled?: boolean
  scrolledScheme: StickyHeaderScrolledScheme
}

function scrollToPageTop(event: MouseEvent<HTMLAnchorElement>) {
  const onHome =
    window.location.pathname === '/' || window.location.pathname === ''
  if (!onHome) return
  event.preventDefault()
  window.scrollTo({ top: 0, behavior: 'smooth' })
  if (window.location.hash) {
    window.history.replaceState(
      null,
      '',
      `${window.location.pathname}${window.location.search}`,
    )
  }
}

export function MorningLogoLink({
  className,
  wordmarkClassName,
  iconWrapClassName,
  iconClassName,
  scrolled = false,
  scrolledScheme,
}: MorningLogoLinkProps) {
  return (
    <a
      href="/#top"
      aria-label="Morning Studio homepage"
      onClick={scrollToPageTop}
      className={cn(
        'flex items-center gap-0 transition-colors duration-300 ease-out md:gap-4',
        scrolled
          ? scrolledScheme.logoClassName
          : 'text-[rgb(255,250,249)] hover:text-white',
        className,
      )}
    >
      <MorningLogoMark
        className={cn('relative z-1500 w-[42px]', iconWrapClassName)}
        iconClassName={cn(
          scrolled ? scrolledScheme.logoMarkClassName : undefined,
          iconClassName,
        )}
      />
      <MorningLogoWordmark
        className={cn(
          'transition-colors duration-300 ease-out',
          scrolled
            ? scrolledScheme.logoWordmarkClassName
            : 'text-[rgb(229,229,223)]',
          wordmarkClassName,
        )}
      />
    </a>
  )
}
